export default __webpack_public_path__ + "static/media/seloIcon.cb0fa9e5.svg";